import React, { Component } from "react";
import "./ChooseCategory.css";
export default class ChooseCategory extends Component {
  constructor(props) {
    super(props);
  }

  // populateCategories = () => {
    // return this.props.categories.map((category,i) => {
    //   return(
    //     <div key={i} className="col-lg-4 col-md-6 col-sm-6 mb-2 mt-2"
    //       onClick={() => this.props.onCategoryChoose(category)}>
    //       <div className="row justify-content-between choose-category-tile">
    //         <div className="col-lg-10 col-md-10 col-sm-10">{category}</div>
    //         <div className="col-lg-2 col-md-2 col-sm-2 text-left">
    //          <i className="material-icons" style={{marginTop: '3px'}}>arrow_forward_ios</i>
    //         </div>
    //       </div>
    //     </div>
    //   )
    // })
  // };

  render() {
    let categoriesView = null;
    let {type, description, categories, title} = this.props;
    if (categories && categories.length > 0) {
      categoriesView = categories.map((category, i) => {
        return (
          <div
            key={i}
            className="col-lg-4 col-md-6 col-sm-6 mb20 mt20"
            onClick={() => this.props.onCategoryChoose(category)}
          >
            <div className="row justify-content-between choose-category-tile">
              <div className="col-lg-10 col-md-10 col-sm-10" 
                style={{alignItems:'center'}}>
                <div style={{textAlign: 'center'}}>
                  {category}
                </div>
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2 text-left" style={{display:'flex', paddingLeft:'8px'}}>
                <i className="material-icons" >
                  arrow_forward_ios
                </i>
              </div>
            </div>
          </div>
        );
      });
    }

    return (
      <div className="col-md-10">
        <div className="row ml-1 text-size">
          <h3 className="category-title">{title}</h3>
        </div>
        <div className="row ml-1 mr0">
          <div className="hr-line" />
        </div>
        <div className="row ml-1 mt20">
          <div className="col-sm-12">
            <div className="row">
              <div className="choose-category-heading">
                {description}
                {type==='Toolkit' && <a className="cursor-pointer" style={{color:'#5099DE'}} onClick={this.props.onClickLearnMore}> Learn more about the categories.</a>}
              </div>
            </div>
          </div>
        </div>
        <div className="row pl-3 mt20">{categoriesView}</div>
      </div>
    );
  }
}
